import * as THREE from 'three';
import * as SceneModule from '../scene.js';
import { airplaneState, setAirplaneMaterials } from './state.js';

// Airplane group reference
export let airplaneGroup = null;

export function createAirplane() {
  // Create a retro wireframe arrow pointing forward
  const group = new THREE.Group();
  
  // Arrow outline - wireframe style like retro arcade radar
  // Arrow points forward (+Z direction after 180 flip)
  const arrowVerts = new Float32Array([
    // Arrow shape pointing forward (nose at front)
    0, 0, 0.5,        // nose (front tip)
    -0.25, 0, -0.3,   // left back corner
    0, 0, -0.15,      // center notch (back)
    
    0, 0, 0.5,        // nose (front tip)
    0, 0, -0.15,      // center notch (back)
    0.25, 0, -0.3,    // right back corner
    
    // Close the back
    -0.25, 0, -0.3,   // left back corner
    0, 0, -0.15,      // center notch
    0.25, 0, -0.3,    // right back corner
  ]);
  
  const arrowGeo = new THREE.BufferGeometry();
  arrowGeo.setAttribute('position', new THREE.BufferAttribute(arrowVerts, 3));
  
  // Wireframe material - retro arcade look
  const wireMat = new THREE.MeshBasicMaterial({ 
    color: 0xffffff,
    wireframe: true,
    transparent: true,
    opacity: 0.9
  });
  
  const arrow = new THREE.Mesh(arrowGeo, wireMat);
  group.add(arrow);
  
  // Store materials for collision color change
  const materials = [wireMat];
  
  // Add edge lines for cleaner wireframe look
  const edgeVerts = new Float32Array([
    // Outline of the arrow
    0, 0, 0.5,        // nose
    -0.25, 0, -0.3,   // left back
    -0.25, 0, -0.3,   // left back
    0, 0, -0.15,      // center notch
    0, 0, -0.15,      // center notch
    0.25, 0, -0.3,    // right back
    0.25, 0, -0.3,    // right back
    0, 0, 0.5,        // back to nose
  ]);
  
  const edgeGeo = new THREE.BufferGeometry();
  edgeGeo.setAttribute('position', new THREE.BufferAttribute(edgeVerts, 3));
  
  const lineMat = new THREE.LineBasicMaterial({ 
    color: 0xffffff,
    transparent: true,
    opacity: 1.0,
    linewidth: 2
  });
  
  const edges = new THREE.LineSegments(edgeGeo, lineMat);
  group.add(edges);
  
  // Add line material to stored materials
  materials.push(lineMat);
  
  // Scale based on airplaneState.size
  group.scale.set(airplaneState.size, airplaneState.size, airplaneState.size);
  
  // Store materials for later color changes
  setAirplaneMaterials(materials);
  
  return group;
}

export function initAirplane() {
  const { scene } = SceneModule;
  if (airplaneGroup) {
    scene.remove(airplaneGroup);
    airplaneGroup = null;
  }
  airplaneGroup = createAirplane();
  airplaneGroup.visible = airplaneState.enabled;
  scene.add(airplaneGroup);
}

export function getAirplaneGroup() {
  return airplaneGroup;
}
